import React from "react";

export default function Footer() {
  return (
    <footer className="p-3">
      <small>
        Developed with ❤ by{" "}
        <a
          href="https://github.com/DiestroCorleone"
          title="GitHub Profile Diestro Corleone"
          target="_blank"
          rel="noreferrer"
        >
          Diestro
        </a>
      </small>
    </footer>
  );
}
